import { CombineIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { MenuCheckboxItem } from "@/components/ui/menu";
import { Toggle } from "@/components/ui/toggle";
import { Tooltip, TooltipPopup, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { NAMESPACES } from "@/i18n/constants";
import type { PanelLayout } from "./use-data-viewer-spec";

export interface PanelLayoutToggleProps {
    layout: PanelLayout;
    onChange: (layout: PanelLayout) => void;
}

/** Pressed draws every stream on one panel; stacked panels are the default. */
export function PanelLayoutToggle({ layout, onChange }: PanelLayoutToggleProps) {
    const { t } = useTranslation(NAMESPACES.FEATURES.DATA_VIEWER, { keyPrefix: "panel-layout-toggle" });
    const label = t("single");

    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger
                    render={
                        <Toggle
                            aria-label={label}
                            onPressedChange={(pressed) => onChange(pressed ? "single" : "stacked")}
                            pressed={layout === "single"}
                            variant={"outline"}
                        />
                    }
                >
                    <CombineIcon />
                </TooltipTrigger>
                <TooltipPopup>{label}</TooltipPopup>
            </Tooltip>
        </TooltipProvider>
    );
}

export function PanelLayoutMenuItem({ layout, onChange }: PanelLayoutToggleProps) {
    const { t } = useTranslation(NAMESPACES.FEATURES.DATA_VIEWER, { keyPrefix: "panel-layout-toggle" });

    return (
        <MenuCheckboxItem
            checked={layout === "single"}
            onCheckedChange={(checked) => onChange(checked ? "single" : "stacked")}
        >
            {t("single")}
        </MenuCheckboxItem>
    );
}
